import React, { useRef } from 'react';

import classNames from 'classnames';

import Details from './partials/Details/Details';

import './GradesTableGradeCell.scoped.scss';

interface Props {
  id: string;
  grade: any;
  marks: any;
  popoverOpened: string;
  updateGradesData: (arg: any) => void;
  setPopoverOpened: React.Dispatch<React.SetStateAction<string>>;
}

const GradesTableGradeCell: React.FC<Props> = ({
  id,
  grade,
  marks,
  popoverOpened,
  updateGradesData,
  setPopoverOpened,
}) => {
  const rootNode = useRef(null);
  const detailsOpened = id === popoverOpened;

  const handleClick = () => {
    setPopoverOpened(id);
  };

  return (
    <td
      className={classNames({ 'grades-table-grade-cell': true, details: detailsOpened })}
      onClick={handleClick}
    >
      <div
        ref={rootNode}
        className={classNames({ content: true, 'no-grade': !grade || !grade.mark })}
      >
        {grade?.mark ? grade.mark.name : '-'}
      </div>

      {detailsOpened && (
        <Details
          marks={marks}
          updateGradesData={updateGradesData}
          gradeId={grade?.mark?.id || null}
          assignmentId={grade?.assignment?.id || null}
          studentId={grade?.student?.id || null}
          onClose={() => {
            setPopoverOpened('');
          }}
          rootNode={rootNode}
        />
      )}
    </td>
  );
};

export default GradesTableGradeCell;
